export default "__VITE_ASSET__DDr2hh$y__";